/**
 * Returns a callback to handle clicks outside of the component.
 * @param {Element} component
 * @param {Function} callback
 * @returns {Function} A callback function
 */
const handleClickOutside = (component, callback) => (e) => {
    if (
        e.target.parentNode &&
        !$(e.target).closest(component).length
    ) {
        callback(e);
    }
};

export default handleClickOutside;



// WEBPACK FOOTER //
// ./src/scripts/components/common/handleClickOutside.js